import dayjs from 'dayjs';
import React from 'react';

function TableHeader() {
    return (
        <thead>
            <tr>
                <th className="" rowSpan="4" colSpan="1">
                    Month
                </th>

                <th className="" colSpan="8">
                    Probably Income
                </th>
            </tr>
            <tr>
                <td colSpan="1">USD</td>
                <td colSpan="1">THB</td>
                <td colSpan="1">EURO</td>
                <td colSpan="1">BDT</td>
            </tr>
        </thead>
    );
}

function ApplicationReportTable() {
    return (
        <div className="pb-10 print:pb-0">
            <table className="report-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    <tr>
                        {/* <td>{dayjs(1707115693 * 1000).format('MMM YYYY')}</td> */}
                        <td>{dayjs().format('MMM YYYY')}</td>
                        <td>100</td>
                        <td>3,574.50</td>
                        <td>92.75</td>
                        <td>11,082</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default ApplicationReportTable;
